import React, { useState, useContext, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { animated } from "react-spring";
import { Editor, EditorState } from "draft-js";
import { Info, Plus } from "react-feather";
import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as CHECK } from "../../assets/icons/CheckmarkСircleFill.svg";
import { ReactComponent as TRASH } from "../../assets/icons/Trash.svg";

import { languages } from "../../Data/languages";

import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";
import { v4 as uuidv4 } from 'uuid';

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { saveAs } from "file-saver";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import { QUOTESTATUS } from "../../Data/statuses";
import { ReactComponent as CANCELQUOTE } from "../../assets/icons/cancel-quote.svg";

import NewButton from "../../NewComponents/NewButton";
import QuoteSummary from "../Quote/QuoteComponents/QuoteSummary";
import { AccountType } from "../../utility/enums";
import "./SingleQuote.css";
import AddCommentonDocument from "../../NewComponents/AddComment/AddCommentonDocument";
import PopUpModal from "../../NewComponents/PopUpModal";
import { fieldValue, firestore, storage } from "../../firebase.config";
import MessageDot from "../../NewComponents/MessageDot";
import EverbaryChatBox from "../../Components/EverbaryChatBox";
import { ReactComponent as DELETE } from "../../assets/icons/delete.svg";
import OrderChatBox from "../../Components/OrderChatBox";
import { FormTextInput } from "../../Components/FormTextInput";
import AddfilesPopUpModel from "../../NewComponents/AddfilesPopUpModel";
import GetFileTypeElement from "../../Data/Functions/getFileType";

const SingleQuoteBackend = ({ windowSize }) => {
  const { quoteID } = useParams();

  const { transitionTo } = useScreenTransition();

  const { showNotification } = useContext(NotificationContext);

  const { userData } = useContext(DataContext);

  const [selectedTab, setSelectedTab] = useState(0);
  const [quoteInfo, setQuoteInfo] = useState(null);
  
  const [saveClientBtnTxt, setSaveClientBtnTxt] = useState("Save");

  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");

  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );
  const [loadedOrder, setLoadedOrder] = useState(false);
  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);
  const [selectedCancelModal, setSelectedCancelModal] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [deleteBtnText, setDeleteBtnText] = useState("Delete");
  const [showAddSourcefiles, setShowAddSourcefiles] = useState(false);
  const [newFiles, setNewFiles] = useState([]);
  // const [files, setNewFiles] = useState([]);
  

  useEffect(() => {
    if (quoteID) {
      const unsubscribe = firestore
        .collection("quotes")
        .doc(quoteID)
        .onSnapshot(
          (doc) => {
            if (doc.exists) {
              if (doc.data().teamId && doc.data().clientFirstName) {
                setClientFirstName(doc.data().clientFirstName);
                setClientLastName(doc.data().clientLastName);
              }
              setQuoteInfo({ ...doc.data(), id: doc.id });

              if (!userData || userData.role === AccountType.TRANSLATER) {
                showNotification(
                  "Error",
                  "You don't have sufficient permissions to see this order. If you think you have the correct permissions, please contact our support team.",
                  "error"
                );
                transitionTo("/office/quotes");
              } else {
                setLoadedOrder(true);
              }
            } else {
              transitionTo("/office/quotes")
              showNotification(
                "Error",
                "There is no quote with that ID. Please, try again.",
                "error"
              );
              transitionTo("/office/quotes");
            }
          },
          (error) => {
            showNotification(
              "Error",
              "There was an error loading the quote info. Please, reload the page.",
              "error"
            );
          }
        );

      return () => unsubscribe();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteID]);


  const formatDate = (timestamp) => {
    if (String(timestamp).length === 10) {
        timestamp *= 1000;
    }

    const date = new Date(timestamp);

    const options = { month: "short", day: "2-digit", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options); 

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM"; 

    hours = hours % 12 || 12;

    return `${formattedDate} @${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  const getFullAddress = (address) => {
    const parts = [
      address.firstName && address.firstName !== "Undefined"
        ? address.firstName || address.recipient
        : "",
      address.lastName && address.lastName !== "Undefined"
        ? address.lastName
        : "",
      address.country && address.country !== "Undefined" ? address.country : "",
      address.region && address.region !== "Undefined" ? address.region : "",
      address.city && address.city !== "Undefined" ? address.city : "",
      address.zipCode && address.zipCode !== "Undefined" ? address.zipCode : "",
      address.street && address.street !== "Undefined" ? address.street : "",
      address.apartment && address.apartment !== "Undefined"
        ? address.apartment
        : "",
    ].filter(Boolean);

    return parts.join(", ");
  };

  const downloadFile = (url) => {
    window.open(url);;
  };

 
  const [addCommentFile, setAddCommentFile] = useState(null);
  const [cancelBtnText, setCancelBtnText] = useState("Cancel Quote");
  const [quoteUpdated, setQuoteUpdated] = useState(false);

  const handleCancelQuote = () => {
    setCancelBtnText("Cancelling...");

    firestore
      .collection("quotes")
      .doc(selectedCancelModal.id)
      .update({
        status: "cancelled",
      })
      .then(() => {
        setQuoteUpdated((q) => !q);
        setCancelBtnText("Cancel Quote");
        setSelectedCancelModal("");
      });
  };

   const handleSaveClientName = async () => {
      if (clientFirstName === "") {
        showNotification(
          "Error",
          "Empty Client Name, please enter a client name.",
          "error"
        );
        return;
      }
      setSaveClientBtnTxt("Saving...");
  
      firestore
        .collection("quotes")
        .doc(quoteInfo.id)
        .update({
          clientFirstName: clientFirstName,
          clientLastName: clientLastName,
        })
        .then(() => {
          // updateClientsName();
        })
        .catch((error) => {
          showNotification(
            "Error",
            "An error ocurred while saving client name. Please, try again.",
            "error"
          );
          setSaveClientBtnTxt("Save");
        })
        .finally(() => {
          setSaveClientBtnTxt("Save");
        });
    };

    const deleteFileFromQuoteHandler = async (file) => {
    if (!file.ref) {
      console.error("File reference missing for:", file);
      showNotification("Error", "File reference is missing.", "error");
      return;
    }
    setDeleteBtnText("Deleting...")
    
    const quoteRef = firestore.collection("quotes").doc(quoteID);
    const storageRef = storage.ref();
    const fileRef = storageRef.child(file.ref);

    try {
      // Remove the file from Firestore quote document
      await quoteRef.update({
        files: fieldValue.arrayRemove(file),
      });

      // Delete the file from Firebase Storage
      await fileRef.delete();

      showNotification("Success", "File deleted from qote.", "success");

    } catch (error) {
      console.error("Error deleting file:", error);
      showNotification("Error", "Failed to remove file from quote. Please try again.", "error");
    }finally{
      setShowDeleteModal(null);
      setDeleteBtnText("Delete");
    }
  };

  const handleSourceFiles = async (e) => {
      const mFiles = e.target.files;
  
      const oID = quoteInfo.id;
  
      for (let i = 0; i < mFiles.length; i++) {
        const fileID = uuidv4();
        setNewFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading' }]));
      }
  
      const storageRef = storage.ref();
  
      for (let i = 0; i < mFiles.length; i++) {
        const subFolder = uuidv4();
        const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);
  
        const downloadToken = uuidv4();
  
        const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");
  
        const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;
  
        var metadata = {
          firebaseStorageDownloadTokens: downloadToken,
          customMetadata: {
            'orderID': oID
          }
        }
  
        const uploadTask = fileRef.put(mFiles[i], metadata);
  
        setNewFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));
  
        uploadTask.on('state_changed', (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setNewFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
        }, (error) => {
          // setNewFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed' } : file));
          setNewFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
          showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
        }, () => {
          setNewFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: new Date().getTime() } : file));
        });
      }
  
    }
  
    const handleDeleteSourceFile = async (file, notify = true) => {
      const checkFile = (file1, file2) => {
        if(file1.id && file2.id){
          return file1.id === file2.id;
        }
        if(file1.ref && file2.ref){
          return file1.ref === file2.ref;
        }
      }
      if (file.ref && (file.status === "complete" || file.timestamp)) {
        try {
          const storageRef = storage.ref();
          const fileRef = storageRef.child(file.ref);
    
          setNewFiles((prevFiles) =>
            prevFiles.map((mFile) =>
              checkFile(mFile, file) ? { ...mFile, status: "deleting" } : mFile
            )
          );
    
    
          await fileRef.delete();
    
          setNewFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
    
          if (notify) {
            showNotification("Success", "File deleted successfully.", "success");
          }
        } catch (error) {
          console.error("Delete error:", error);
          if (notify) {
            showNotification("Delete Error", "Failed to delete file. Please try again.", "error");
          }
             setNewFiles((prevFiles) =>
               prevFiles.map((mFile) =>
                 checkFile(mFile, file) ? { ...mFile, status: "complete" } : mFile
               )
             );
           }
        }else if (file.status === 'failed') {
          setNewFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
        } else {
          file.task.cancel();
          setNewFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
        }
    };

  const handleSubmitSourceFiles = async () => {
     const filteredFiles = newFiles
      ?.filter((f) => f.ref && f.url && f.status === "complete")
      .map((file) => ({
        name: file.name,
        ref: file.ref,
        url: file.url,
        type: "source",
        size: file.file ? file.file.size : file.size,
        format: file.file ? file.file.type : file.format,
        timestamp: file.timestamp,
      }));

    if (!filteredFiles.length) {
      showNotification("Warning", "No valid files to upload.", "warning");
      return;
    }

    const quoteRef = firestore.collection("quotes").doc(quoteID);

    try {
      await quoteRef.update({
        files: fieldValue.arrayUnion(...filteredFiles),
      });
      setShowAddSourcefiles(false)
      showNotification("Success", "Files successfully added to the quote.", "success");
      setNewFiles([]);
    } catch (error) {
      showNotification("Error", "Failed to update quote with files.", "error");
      console.error("Error updating quote with files:", error);
    }
  };

  const checkExpeditedServiceOption = useCallback(async (quoteTeamData, currentQuoteInfo) => {
    if(quoteTeamData && quoteTeamData.isCreatedByMarketingCampaign){
        const expeditedServiceOption = quoteTeamData.expeditedServices || "paid";
        if (currentQuoteInfo?.expeditedServiceOption !== expeditedServiceOption) {
            setQuoteInfo(prev => ({...prev, expeditedServiceOption}));
        }
    }
  }, []);

  const [quoteTeamData, setQuoteTeamData] = useState(null);

  useEffect(() => {
    if(quoteInfo && quoteInfo.teamId){
      const unsubscribe = firestore.collection("teams").doc(quoteInfo.teamId).onSnapshot((doc) => {
        if(doc.exists){
          setQuoteTeamData(doc.data());
        }
      });

      return () => unsubscribe();
    }
  }, [quoteInfo?.teamId]);

  useEffect(() => {
    if(quoteTeamData && quoteInfo){
      checkExpeditedServiceOption(quoteTeamData, quoteInfo);
    }
  }, [quoteTeamData, quoteInfo, checkExpeditedServiceOption]);

  const checkHowDidYouHearInDB = async () => {
    if(quoteInfo && quoteInfo.userID){
      await firestore.collection("howDidTheyHear").doc(quoteInfo.userID).get().then((doc) => {
        if(doc.exists){
          setHowDidYouHear(doc.data().howDidYouHear);
        }
      });
    }else{
      await firestore.collection("howDidTheyHear").where("email", "==", quoteInfo.email).get().then((qSnap) => {
        if(qSnap.empty){
          return;
        }
        const doc = qSnap.docs[0];
        if(doc.exists){
          setHowDidYouHear(doc.data().howDidYouHear);
        }
      });
    }

  }

  const [howDidYouHear, setHowDidYouHear] = useState(null);

  useEffect(() => {
    if(quoteInfo && quoteInfo.howDidYouHear){
      setHowDidYouHear(quoteInfo.howDidYouHear);
    }else if(quoteInfo){
      checkHowDidYouHearInDB();
    }

  }, [quoteInfo])

  return (
    <>
      {addCommentFile ? (
        <AddCommentonDocument
          selectedFile={addCommentFile}
          orderInfo={quoteInfo}
          handleClose={() => setAddCommentFile(null)}
        />
      ) : (
        <>
          <AccountNavBar
            showButton={true}
            windowSize={windowSize}
            selectedTab={"quotes"}
            accountMainPadding={false}
            bgTransparent={true}
            breadLinkType="quote"
            breadLink={`Quote #${
              quoteInfo ? (quoteInfo.quoteNumber) : ""
            }`}
            admin={true}
          >
            {!loadedOrder && (
              <NoData
                loadingText="quote"
                type="order"
                loading={true}
                showBtn={false}
              />
            )}

             {showAddSourcefiles && (
              <AddfilesPopUpModel windowSize={windowSize} onCancel={() => setShowAddSourcefiles(false)} files={newFiles} handleFiles={handleSourceFiles} handleDeleteFile={handleDeleteSourceFile} onClose={() => setShowAddSourcefiles(false)} onSave={handleSubmitSourceFiles} />
            )}

            {selectedCancelModal !== "" && (
              <PopUpModal
                title={"Cancel Quote"}
                backBtnText="Back to Quotes"
                subText="Are you sure you want to cancel this quote?"
                text={(selectedCancelModal.quoteNumber)}
                btnText={cancelBtnText}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                showClose
                onClose={() => setSelectedCancelModal("")}
                onClick={() => handleCancelQuote()}
                onBackClick={() => {
                  setSelectedCancelModal("");
                }}
                disableBtn={cancelBtnText === "Cancelling..."}
              >
                <CANCELQUOTE />
              </PopUpModal>
            )}

             {showDeleteModal && (
              <PopUpModal
                title={"Delete File"}
                backBtnText="Cancel"
                text={"Are you sure you want to delete this file?"}
                subText={showDeleteModal.name}
                btnText={deleteBtnText}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                showClose
                onClose={() => setShowDeleteModal(null)}
                onClick={() => deleteFileFromQuoteHandler(showDeleteModal)}
                onBackClick={() => {
                  setShowDeleteModal(null);
                }}
                disableBtn={deleteBtnText === "Deleting..."}
              >
                <DELETE />
              </PopUpModal>
            )}

            {loadedOrder && (
              <div className="mainOrderPageContainer">
                <div className="mainOrderTitleWrapper">
                  <h2 className="createOrderNavbarMenuTitle">
                    Quote #{(quoteInfo.quoteNumber)}
                  </h2>
                  <div className="mainOrderStatusWrap">
                    {showStatusHoverBox ? (
                      <div className="mainOrderStatusHover">
                        <p className="title">
                          Status:{" "}
                          {QUOTESTATUS[quoteInfo.status.toLowerCase()][0]}
                        </p>
                        <p className="subTitle">
                          {QUOTESTATUS[quoteInfo.status.toLowerCase()][2]}
                        </p>
                      </div>
                    ) : null}
                    <div
                      className="mainOrderOrderStatus"
                      style={{
                        backgroundColor: QUOTESTATUS[quoteInfo.status]
                          ? QUOTESTATUS[quoteInfo.status][1]
                          : "",
                      }}
                      onMouseOver={() => setShowStatusHoverBox(true)}
                      onMouseOut={() => setShowStatusHoverBox(false)}
                    >
                      {quoteInfo.status}
                      <Info className="statusIcon" />
                    </div>
                    {quoteInfo.orderID && quoteInfo.status === "ordered" && (
                      <div
                        className=" sm:block hidden mainOrderOrderStatus bg-white cursor-pointer"
                        onClick={(e) => {
                          transitionTo(
                            `/office/translations/${quoteInfo.orderID}`,
                            e
                          );
                        }}
                      >
                        Go to The Order
                      </div>
                    )}
                  </div>
                </div>
                {quoteInfo.status !== "cancelled" && (
                  <div className="mainOrderSecondaryContent mainOrderTransBtnWrap">
                    <NewButton
                      text={"Cancel Quote"}
                      width={"100%"}
                      customIcon={<TRASH />}
                      smallPadding
                      whiteBtn
                      back
                      onClick={() => {
                        setSelectedCancelModal({
                          id: quoteInfo.id,
                          quoteNumber: quoteInfo.quoteNumber,
                        });
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            {loadedOrder && (
              <div className="mainOrderPageContainer">
                <div className="mainOrderPageContainerOptions">
                  <div id="mainPrimary" className="mainOrderPrimaryContent">
                    <div className="accountSettingsMenu mainQuoteTabMenu grid-cols-4">
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(0)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${
                              selectedTab === 0 && "selectedTab"
                            }`}
                          >
                            Quote Info
                          </p>
                        </div>
                        <div className="accountSettingsMenuSpacer">
                          <div></div>
                        </div>
                      </div>
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(1)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${
                              selectedTab === 1 && "selectedTab"
                            }`}
                          >
                            Files
                          </p>
                        </div>
                        <div className="accountSettingsMenuSpacer">
                          <div></div>
                        </div>
                      </div>
                      <div
                        className="accountSettingsMenuTab"
                        onClick={() => setSelectedTab(2)}
                      >
                        <div className="accountSettingMenuTextWrap">
                          <p
                            className={`accountSettingMenuText ${
                              selectedTab === 2 && "selectedTab"
                            }`}
                          >
                            Chat with client
                          </p>
                          {selectedTab !== 2 && <MessageDot chatId={quoteInfo.generalChatId}/>}
                        </div>
                      </div>
                      {(userData.role === AccountType.SUPPORT ||
                        userData.role === AccountType.SUPPORTPLUS ||
                        userData.role === AccountType.OWNER) && (
                          <div className="accountSettingsMenuTab" onClick={() => setSelectedTab(3)}>
                            <div className="accountSettingMenuTextWrap">
                              <p className={`accountSettingMenuText ${selectedTab === 3 && "selectedTab"}`}>
                                eVerbary chat
                              </p>
                              {selectedTab !== 3 && <MessageDot chatId={quoteInfo.everbaryChatId} type="everbary"/>}
                            </div>
                          </div>
                        )}
                    </div>

                    {selectedTab === 0 && (
                      <div className="quotePrimaryOptionsWrapper accSingleQuoteDataWrapper">
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">
                              Order Time Line
                            </h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Created
                            </p>
                            <p className="accSingleInvoiceText">
                              {formatDate(quoteInfo.timestamp)}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Quote Info</h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Language
                            </p>
                            <p className="accSingleInvoiceText">
                              {getLanguage(quoteInfo.languageFrom)} to{" "}
                              {getLanguage(quoteInfo.languageTo)}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <p />
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Type
                            </p>
                            <p className="accSingleInvoiceText">{quoteInfo.certified ? "Certified Translation" : "Standard Translation"}</p>
                          </div>
                        </div>
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Client</h6>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Name
                            </p>
                            <p className="accSingleInvoiceText capital">
                              {quoteInfo.name}
                            </p>
                          </div>
                          <div className="accSingleQuoteDataContainer">
                            <p></p>
                            <p className="accSingleInvoiceText accSingleInvoiceSubText">
                              Email
                            </p>
                            <p className="accSingleInvoiceText">
                              {quoteInfo.email}
                            </p>
                          </div>
                        </div>
                        <div className="accSingleQuoteDataWrap">
                          <div className="accSingleQuoteDataContainer">
                            <h6 className="accSingleQuoteTitle">Services</h6>

                            {quoteInfo.expedited || quoteInfo.expeditedPlus ? (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  {quoteInfo.expeditedPlus
                                    ? "Expedited+"
                                    : "Expedited"}{" "}
                                  Turnaround
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </>
                            ) : quoteInfo.notarization ? (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Notarization
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </>
                            ) : quoteInfo.hardCopy ? (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Mail Hard Copy
                                </p>
                                <p className="accSingleInvoiceText capital">
                                {getFullAddress(quoteInfo.hardCopyExtra)}<br/><span className="font-[600]">{quoteInfo.hardCopyExtra.method ? " (USPS " + quoteInfo.hardCopyExtra.method + (quoteInfo.hardCopyExtra.requireSignature ? " - required signature" :"") + ")" : ""}</span>

                                </p>
                              </>
                            ) : (
                              <>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  No Additional Services Available
                                </p>
                              </>
                            )}
                          </div>

                          {quoteInfo.expeditedPlus &&
                            (quoteInfo.notarization || quoteInfo.hardCopy) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Expedited+ Turnaround
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </div>
                            )}

                          {quoteInfo.notarization &&
                            (quoteInfo.expedited ||
                              quoteInfo.expeditedPlus) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Notarization
                                </p>
                                <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>
                              </div>
                            )}

                          {quoteInfo.hardCopy &&
                            (quoteInfo.expedited ||
                              quoteInfo.expeditedPlus ||
                              quoteInfo.notarization) && (
                              <div className="accSingleQuoteDataContainer">
                                <p></p>
                                <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                  Mail Hard Copy
                                </p>
                                <p className="accSingleInvoiceText capital">
                                {getFullAddress(quoteInfo.hardCopyExtra)}<br/><span className="font-[600]">{quoteInfo.hardCopyExtra.method ? " (USPS " + quoteInfo.hardCopyExtra.method + (quoteInfo.hardCopyExtra.requireSignature ? " - required signature" :"") + ")" : ""}</span>

                                </p>
                              </div>
                            )}
                        </div>
                        {quoteInfo && quoteInfo.translatorCertification && <div className="accSingleQuoteDataWrap">
                            <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">Individual Translator Certification</h6>
                              <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>

                            </div>
                          </div>}
                      </div>
                    )}

                    {selectedTab === 0 && quoteInfo.notes && (
                      <div className="quotePrimaryOptionsWrapper">
                        <h4 className="quotePrimaryTitle">
                          General Notes From The Clients
                        </h4>
                        {quoteInfo.notes && quoteInfo.notes.blocks ? (
                          editorState.getCurrentContent().getPlainText() !==
                            "" && (
                            <div className="accSingleInvoiceText">
                              <Editor
                                editorState={editorState}
                                onChange={(editorState) =>
                                  setEditorState(editorState)
                                }
                                readOnly
                              />
                            </div>
                          )
                        ) : (
                          <p className="accSingleInvoiceText">
                            {quoteInfo.notes
                              ? quoteInfo.notes
                              : quoteInfo.clientNotes}
                          </p>
                        )}
                      </div>
                    )}

                      {selectedTab === 0 && howDidYouHear && howDidYouHear.selectedOption && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">How did they hear about us</h4>
                          <h6 className="accSingleInvoiceText accSingleInvoiceSubText capitalize mt-2">
                            {howDidYouHear.selectedOption} {howDidYouHear.hasInput && `: ${howDidYouHear.inputText}`}
                          </h6> 
                        </div>
                      )}

                    {selectedTab === 1 && quoteInfo && (

                      <div className="quotePrimaryOptionsWrapper">

                            <div className="w-full flex justify-between items-center">

                              <div className="memberOrderStatus">

                                <h4 className="quotePrimaryTitle">Source Files</h4>

                              </div>

                              { <div>
                                <NewButton
                                  back={true}
                                  text={"Add New File"}
                                  customIcon={<Plus className="h-4 w-4" />}
                                  onClick={() => setShowAddSourcefiles(true)}
                                />
                              </div>}

                            </div>
                            <div className="accSingleQuoteFileWrap mt-2">
                              {quoteInfo.files
                                .filter(
                                  (f) =>
                                    f.type === "source" ||
                                    f.type === "reference" ||
                                    f.type === "client"
                                )
                                .map((file, index) => (
                                  <>
                                    <div
                                      key={index}
                                      className="fileUploaderLineOuter"
                                    >
                                      <div className="fileUploaderLine">
                                        <div className="fileUploaderLineInfo flex-1">
                                          <GetFileTypeElement file={file}/>
                                          <p
                                            className="fileUploaderLineName w-max"
                                          > 
                                            {file.name}
                                          </p>
                                        </div>
                                        {file.status !== "uploading" &&
                                          file.timestamp && (
                                            <p className="fileUploaderLineSize max-sm:hidden">
                                              {formatDate(file.timestamp)}
                                            </p>
                                          )}

                                        {file.status === "uploading" ? (
                                          <div className="fileUploaderLineProgressContainer">
                                            <animated.div
                                              style={{
                                                width: `${file.progress}%`,
                                              }}
                                              className="fileUploaderLineProgress"
                                            />
                                          </div>
                                        ) : null}

                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', gap: '5px' }}>
                                          <DOWNLOAD
                                            className="hardCopyAddressIcon"
                                            style={{ cursor: 'pointer' }}
                                            
                                            onClick={() => downloadFile(file.url)}
                                          />
                                          <button
                                            className="commentBtn"
                                            onClick={() => {
                                              setShowDeleteModal(file)
                                            }}
                                          >
                                            <TRASH />
                                          </button>

                                        </div>
                                      </div>
                                    </div>
                                    {quoteInfo.files.length - 1 !== index && (
                                      <div className="accSingleQuoteFileDivider"></div>
                                    )}
                                  </>
                                ))}
                            </div>
                          </div>
                    )}

                    {selectedTab === 0 && quoteInfo.teamId && (
                      <div className="quotePrimaryOptionsWrapper">
                        <h4 className="quotePrimaryTitle">Your Client</h4>
                        <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                          If submitted, the client field will be included in
                          emails, in translations, and in your invoice.
                        </h6> 

                        <div className="accSingleOrderCCEmailWrap">
                          <FormTextInput
                            placeholder="Client First Name"
                            value={clientFirstName}
                            onChange={setClientFirstName}
                            onKeyDown={(e) =>
                              e.key === "Enter" &&
                              handleSaveClientName()
                            }
                            disabled={!(userData && (( userData.teamId && quoteInfo.teamId && userData.teamId === quoteInfo.teamId) || userData.role !== "client"))}
                          />
                          <FormTextInput
                            placeholder="Client Last Name"
                            value={clientLastName}
                            onChange={setClientLastName}
                            onKeyDown={(e) =>
                              e.key === "Enter" &&
                              handleSaveClientName()
                            }
                            disabled={!(userData && (( userData.teamId && quoteInfo.teamId && userData.teamId === quoteInfo.teamId) || userData.role !== "client"))}
                          />
                          <NewButton
                            width="86px"
                            text={saveClientBtnTxt}
                            back
                            whiteBtn
                            icon={false}
                            onClick={() => {
                              handleSaveClientName();
                            }}
                            disabled={
                              clientFirstName === "" ||
                              saveClientBtnTxt === "Saving.." || 
                              !(userData && (( userData.teamId && quoteInfo.teamId && userData.teamId === quoteInfo.teamId) || userData.role !== "client"))
                            }
                          />
                        </div>
                      </div>
                    )}

                    {selectedTab === 2 && (
                      <div className="quotePrimaryOptionsWrapper">
                         <OrderChatBox
                            type="quote"
                            userId={userData.id}
                            userRole={userData.role}
                            orderChatId={quoteInfo.everbaryChatId || null}
                            orderData={quoteInfo}
                            userData={userData}
                          />
                      </div>
                    )}

                    {selectedTab === 3 &&
                    (userData.role === AccountType.OWNER ||
                      userData.role === AccountType.SUPPORT ||
                      userData.role === AccountType.SUPPORTPLUS) && (
                      <div className="quotePrimaryOptionsWrapper">
                        <EverbaryChatBox
                          type="quote"
                          userId={userData.id}
                          userRole={userData.role}
                          orderChatId={quoteInfo.generalChatId || null}
                          orderData={quoteInfo}
                          userData={userData} />
                      </div>
                    )}
                  </div>
                </div>

                <div className="mainOrderSecondaryContent">
                  <div className="mainOrderSecondaryContentWrap">
                    <div style={{ marginTop: "1rem" }}>
                      <QuoteSummary
                        key={`${quoteInfo.id}-${quoteInfo.expeditedServiceOption}-${quoteInfo.status}`}
                        languageFrom={quoteInfo.languageFrom}
                        languageTo={quoteInfo.languageTo}
                        quote={quoteInfo}
                        windowSize={windowSize}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </AccountNavBar>
        </>
      )}
      ;
    </>
  );
};

export default SingleQuoteBackend;
